import * as helper from "../../helpers/get_all_users";

import { ALL_USER_LIST } from "../../../constants/reducer_names";
import { FailedUserFetchResponse } from "../../../constants/error_messages";
import _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import { getAllUsers } from "../../api/user_management";
import { routingProfile } from "../../api/helperspi/user_helperapi";

export const initialState = {
  loading: false,
  error: {
    hasError: false,
    errorMessage: "",
  },
  availableUsers: {} as any,
  isGetuser: false,
  users: [] as any,
  supervisorList: [] as any,
  userCopy: [] as any,
  usersecondCopy: [] as any,
  userTableData: [] as any,
  userSearchData: [] as any,
  userCopySearchData: [] as any,
  openAdvanceFilterSearch: false,
  openSelectDropdown: false,
  filterType: [] as any,
  newFilterType: "",
  reportTo: [] as any,
  routingProfile: [] as any,
  testTableData: [] as any,
  advancedSearchData: {
    role: [] as any,
    routingProfileName: [] as any,
    reportToName: [] as any,
  },
  searchName: "",
  isVisibleAgent: false,
  selectedAgent: [] as any
};

const allUserSlice = createSlice({
  name: ALL_USER_LIST,
  initialState,
  reducers: {
    updateTableData: (state, { payload }) => {
      const index = helper.checkIfExist(state, payload?.emailId);
      if (index === -1) {
        state.users.push(payload);
        state.userTableData.push(helper.getMappedObject(state, payload));
        state.userSearchData.push(helper.getMappedObject(state, payload));
      } else {
        state.users[index] = payload;
        const subIndex = helper.checkIfTableRowExist(state, state.users[index]?.emailId);
        state.userTableData[subIndex] = helper.getMappedObjectForUpdate(state, payload, subIndex);
        state.userSearchData[subIndex] = helper.getMappedObjectForUpdate(state, payload, subIndex);
      }
    },
    selectedAgent: (state, { payload }) => {
      let datavalue;
      let index = state.selectedAgent.findIndex((item: any) => item.uid === payload.uid);
      if (index > -1) {
        datavalue = [...state.selectedAgent];
        datavalue.splice(index, 1);
      } else {
        datavalue = [...state.selectedAgent];
        datavalue.push(payload);
      }
      state.selectedAgent = datavalue;
    },
    removeAgent: (state, { payload }) => {
      let datavalue;
      let index = state.selectedAgent.findIndex((item: any) => item.uid === payload.uid);
      if (index > -1) {
        datavalue = [...state.selectedAgent];
        datavalue.splice(index, 1);
      }
      state.selectedAgent = datavalue;
    },
    setVisible: (state, { payload }) => {
      state.isVisibleAgent = payload;
    },

    deleteUsert: (state, { payload }) => {
      const index = helper.checkIfExist(state, payload?.agentId);
      const subIndex = helper.checkIfTableRowExist(state, payload?.agentId);
      if (index !== -1) {
        state.users.splice(index, 1);
        state.userTableData.splice(subIndex, 1);
        state.userSearchData.splice(subIndex, 1);
      }
    },

    role: (state, { payload }) => {
      state.advancedSearchData.role = payload.role === undefined ? "" : payload.role;
      helper.dataSearch(state);
    },
    routingProfileName: (state, { payload }) => {
      state.advancedSearchData.routingProfileName = payload.routingName === undefined ? "" : payload.routingName;
      helper.dataSearch(state);
    },
    reportToName: (state, { payload }) => {
      state.advancedSearchData.reportToName = payload.reportName === undefined ? "" : payload.reportName;
      helper.dataSearch(state);
    },

    openSearchFilter: (state) => {
      state.openAdvanceFilterSearch = !state.openAdvanceFilterSearch;
    },
    openDropDown: (state) => {
      state.openSelectDropdown = !state.openSelectDropdown;
    },

    clearFilter: (state) => {
      state.userSearchData = state.userTableData;
      state.advancedSearchData.role = [];
      state.advancedSearchData.routingProfileName = [];
      state.advancedSearchData.reportToName = [];
    },

    searchForAgent: (state, { payload }) => {
      state.searchName = payload;
      if (payload.length >= 1) {
        state.isVisibleAgent = true;
        state.users = state.userCopy.filter((data: any) => {
          return helper.filterData(data, payload);
        });
      } else {
        state.isVisibleAgent = false;
        state.users = state.usersecondCopy;
      }
    },

    applySearchFilter: (state, { payload }) => {
      if (state.advancedSearchData.role.length === 0 || state.advancedSearchData.routingProfileName.length === 0 || state.advancedSearchData.reportToName.length === 0) {
        if (payload.length < 1) {
          helper.resetFilter(state);
        } else {
          state.userSearchData = state.userTableData.filter((data: any) => {
            return helper.filterSearch(data, payload);
          });
        }
      } else {
        if (
          state.advancedSearchData.role.length !== 0 ||
          state.advancedSearchData.routingProfileName.length !== 0 ||
          state.advancedSearchData.reportToName.length !== 0
        ) {
          if (payload.length < 2) {
            helper.resetFilter(state);
          } else {
            state.userSearchData = state.userCopySearchData.filter((data: any) => {
              return helper.filterSearch(data, payload);
            });
          }
        }
      }
    },

    updateStatus: (state, { payload }) => {
      const index = state.users.findIndex((user: any) => user?.email?.toString() === payload?.email?.toString());
      if (index !== -1) {
        state.users[index].statusName = payload.status;
      }
    },

    setRoutingProfile: (state, { payload }) => {
      state.routingProfile = payload
    },


    reset: () => { },
  },

  extraReducers: (builder) => {
    builder.addCase(getAllUsers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllUsers.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode === 200) {
        state.users = payload?.data?.getUserListByRoleId;
        state.userCopy = payload?.data?.getUserListByRoleId;
        state.usersecondCopy = payload?.data?.getUserListByRoleId;
        state.reportTo = helper.getReportTo(payload?.data?.getUserListByRoleId);
        // state.routingProfile = helper.getRoutingProfile(payload?.data?.getUserListByRoleId);
        helper.mapResponseDataToTable(state, payload?.data?.getUserListByRoleId);
        state.isGetuser = true;
        state.error.hasError = false;
        state.error.errorMessage = "";
      } else {
        state.error.hasError = true;
        state.error.errorMessage = payload?.message ?? FailedUserFetchResponse;
      }

      state.loading = false;
    });
    builder.addCase(getAllUsers.rejected, (state, { payload }: any) => {
      state.error.hasError = true;
      state.error.errorMessage = payload?.message ?? FailedUserFetchResponse;
      state.loading = false;
    });

    builder.addCase(routingProfile.fulfilled, (state, { payload }: any) => {
      const data_ :any= []
      payload?.data?.getRoutingListRes?.forEach((element :any) => {
        if(element.routing_prof_name){
          data_.push(element.routing_prof_name)
        }
      });
      state.routingProfile = data_
    });
  },
});
export const GetAlluserActions = allUserSlice.actions;
export default allUserSlice.reducer;
